<template>
	<div style="padding-top: 85px;">
		<headerList></headerList>
		
		<div class="detail-box">
			<!-- 详情版心主要内容 -->
			<div class="detail-main">
				
				<div class="ptb-15 flex flex-y- flex-x-s f-14 c-66">
					<span>当前位置: </span>
					<router-link :to="{path: '/index'}" class="ml-5 shou">首页</router-link >
					<span class="iconfont iconxiangyoujiantou mlr-5"></span>
					<span>{{PIC_CAT}}</span>
					<span class="iconfont iconxiangyoujiantou mlr-5"></span>
					<span>{{SYS_TOPIC}}</span>
				</div>
				
				<div class="flex flex-y-s mt-10">
					<!-- 左侧内容 -->
					<div class="img-detail-left bg-ff">
						<!-- 标题 -->
						<div class="title flex plr-20 ptb-15 b-b">
							<span class="f-26 c-66 bold flex-box">{{SYS_TOPIC}}</span>
							<img class="ml-40 title-icon" src="../assets/detail-icon.png" alt="">
						</div>
						<!-- 图片内容 -->
						<div class="p-20">
							<div class="detail-img relative">
								<video controls x5-playsinline playsinline :webkit-playsinline="true" :poster="middlePath"  :src="$baseURL+ '/pub/api/media.mp4?s=S' + suijinum + 'S&i=' + id + '_' + tid"></video>
							</div>
						</div>
						<!-- 描述介绍 -->
						<ul class="detail-img-mask b-t b-b flex flex-x-s">
							<li class="t-c bold b-r" :class="nav_index==0?'on':''" @click="changeIndex(0)">素材介绍</li>
							<!-- <li class="t-c bold b-r">下载记录</li> -->
							<li class="t-c bold b-r" :class="nav_index==2?'on':''" @click="changeIndex(2)">用户评价</li>
						</ul>
						<div class="detail-mask plr-20 pt-20 pb-40">
							<!-- 素材 -->
							<div  v-show="nav_index == 0">
								<p class="f-14 c-33" v-html="SUCAIJIESHAO"></p>
								<p class="banquan f-12 mt-30">版权信息：本站所有资源均受著作权保护，未经许可不得使用，不得转载， 摘编。如有问题请及时<router-link  class="route-a" :to="{path: '/about?id=14&name=联系我们'}">联系我们</router-link>。</p>
								<div class="flex flex-x-s mt-30 mb-10">
									<span class="mr-15 f-16 c-33">分享:</span>
									<share :config="config"></share>
								</div>
							</div>
							<!-- <div></div> -->
							<!-- 评论 -->
							<div class=""  v-show="nav_index == 2">
								<!-- 评论发布表单 -->
								<div class="flex flex-y-s comment-add">
									<img :src="picture" class="head-img" v-if="picture" />
									<img v-else src="../assets/images/noface.gif" class="head-img" />
									<div class="flex flex-box">
											<textarea name="" id="" placeholder="说点什么吧" maxlength="200"  class="flex-box" v-model="content"></textarea>
											<div class="add-btn shou" @click="commentAdd">我要评论</div>
									</div>
								</div>
								<p v-show="username" class="f-12 c-66 mt-10 " style="padding-left: 90px;">Hello {{username}} ！</p>
								<!-- 评论列表 -->
								<div class="mt-50 comment-list">
									<div class="f-16">共有 <span class="f-26 c-f0">{{com_totalCount}}</span> 条评论</div>
									<ul class="plr-30">
										<li class="ptb-20 flex flex-y-s comment-detail" v-for="item,index in com_list" :key="index">
											<img :src="item.picture" class="head-img mr-30" v-if="item.picture" />
											<img v-else src="../assets/images/noface.gif" class="head-img mr-30" />
											<div class="flex-box flex">
												<div class="flex-box">
													<div class="flex">
														<div>
															<span class="name f-14">{{item.loginName}}</span>
															<span class="date f-12 c-c2 ml-10">{{item.auditTime}}</span>
														</div>
														<div>{{item.discussStatus==0?'待审核':''}}</div>
														
													</div>
													<div class="mt-20 comment c-33 f-12">{{item.content}}</div>
												</div>
												<!-- <span class="ml-50 num mr-10">{{index + 1}}F</span> -->
											</div>
										</li>
									</ul>
									<div class="c-c2 t-c mt-20 shou f-14" v-show="!last" @click="commentNext">查看更多</div>
								</div>
							</div>
							
						</div>
					</div>
					
					<!-- 右侧内容 -->
					<div class="img-detail-right">
						<div class="p-15 user-info  bg-ff">
							<!-- 谁-发布与什么时候 -->
							<div class=" flex flex-x-s">
								<!-- <img src="" alt="" class="head"> -->
								<div class="ml-15"> <span style="color: #10c55b;margin-right: 5px;">{{SYS_AUTHORS?SYS_AUTHORS:'平台'}}</span>于<span style="color: #10c55b;margin-left: 5px;">{{SYS_CREATED}}</span>上传</div>
							</div>
							<!-- 原创-侵权 -->
							<div class=" flex flex-x-s mt-20 mb-10">
								<div class="flex flex-x-s"><img class="vip-icon" src="../assets/images/detail-vip-icon.png" /> <span class="f-14 bold c-66 ml-5">原创作品</span></div>
								<router-link :to="{path: '/about?id=14&name=联系我们'}">
									<div class="flex flex-x-s ml-20 shou"><img class="vip-qq" src="../assets/images/detail-bz-icon.png" /> <span class="f-12 c-c2 ml-5">侵权投诉</span></div>
								</router-link>
							</div>
							<!-- 选套餐 -->
							<div class="mt-20 plr-10  f-14 c-99">
								<div class="mt-10" v-for="item,index in more" :key="index">{{item.name}}：{{item.value}}</div>
							</div>
							<!-- 下载-收藏 -->
							<div class="flex mt-25 cz-btn">
								<div class="down-btn radius-5 flex-c c-ff shou" v-if="!price || is_buy"  @click="dowLoadFile"> <span class="iconfont icondownload"></span> <span class="f-16 ml-5">下载素材</span></div>
								<div class="down-btn radius-5 flex-c c-ff shou" v-else  @click="buydetail"> <span class="iconfont icondownload"></span> <span class="f-16">购买音频</span></div>
								<div class="ml-10 flex-box collect-btn radius-5 flex-c shou" @click="collectopt"> <span class="iconfont" :class="isCollected?'iconzan1':'iconzan'"></span> <span class="f-16 ml-5">{{isCollected?'取消收藏':'收藏'}}</span></div>
							</div>
							<!-- 数据 -->
							<div class="flex mt-5">
								<div class="flex-box flex-c c-c2"><span class="iconfont iconyanjing f-14"></span> <span class="f-14 ml-5">{{lookCount}}</span></div>
								<span class="f-16 c-c2">|</span>
								<div class="flex-box flex-c c-c2"><span class="iconfont icondownload f-14"></span> <span class="f-14 ml-5">{{uploadCount}}</span></div>
								<span class="f-16 c-c2">|</span>
								<div class="flex-box flex-c c-c2"><span class="iconfont iconcollection2 f-14"></span> <span class="f-14 ml-5">{{collectCount}}</span></div>
							</div>
						</div>
						<!-- 特邀设计师 -->
						<div class="detail-ty-box bg-ff mtb-10 flex plr-25 flex-x-s">
							<img src="../assets/images/detail-award-icon.png" class="mr-15" alt="">
							<span class="f-16 c-33">特邀设计师供稿</span>
						</div>
						<!-- 标签 -->
						<div class="plr-30 ptb-35 bg-ff mt-8" v-show="keywords.length">
							<p class="f-14 bold c-33">标签</p>
							<div class="flex flex-x-s">
								<div class="mt-8 mr-8 detail-design shou" @click="enterSearch('KEYWORDS_s',item)" v-for="item,index in keywords" :key="index">{{item}}</div>
							</div>
						</div>
					</div>
					
				</div>
				
				<!-- 相关音频推荐 -->
				<div class="mt-30" v-show="about_list.length">
					<p class="f-16 bold c-29">相关音频推荐</p>
					
					<div class="music-list flex flex-x-s flex-wrap">
						<div class="music-detail-box mt-25 bg-ff flex flex-y-s relative" v-for="item,index in about_list" :key="index">
							<img :src="item.middlePath" alt="">
							<!-- 视频标题以及跳转 -->
							<div class="absolute flex plr-20 ptb-10">
								<span class="iconfont iconbofang"></span>
								<div class="flex-box ml-15 onelist">{{item.SYS_TOPIC}}</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 以上是相关推荐 -->
			</div>
		</div>
		
		<footer-view></footer-view>
	</div>
</template>

<script>
import headerView from './header.vue'
import footerView from './footer.vue'
import headerList from './header_nav.vue'
export default {
  data () {
    return {
			config: {
				sites: ['weibo', 'douban', 'qzone','wechat']
			},
			nav_list: [],
			nav_index: 0,
			id:0,
			tid:0,
			attId: 0,
			middlePath: '', // 大图
			SYS_TOPIC: '', // 标题
			SUCAIJIESHAO: '', // 介绍
			SYS_CREATED: '', // 入库时间
			SYS_AUTHORS: '', // 作者
			about_list: [], // 相关资源
			more: [], // 相关信息
			keywords: [], // 关键字
			SYS_CREATED: '',
			
			lookCount: 0,
			collectCount:0,
			isCollected: false,
			doclibId: 0, // 文档类型id
			doclibName: '',
			content: '',
			picture: '',
			username: '',
			pageIndex: 1,
			com_totalCount: 0,
			com_totalPages: 0,
			last: true,
			com_list: [],
			detail_name: '',
			price: '',
			is_buy: false,
			RESOURCEID:0,
			PIC_CAT: '',
			uploadCount:0,
			suijinum: 0,
		}
  },
	
	components: {
		headerView,
		footerView,
		headerList
	},

  created () {
		let _this = this
		_this.id = _this.$route.query.id
		_this.tid = _this.$route.query.tid
		_this.suijinum = _this.randomNum(0,10000)
		this.binddetailInfo()
		this.bindaboutList() // 获取相关资源
	},
	
	async mounted () {
		let _this = this
		_this.$Spin.show()
		
		const lookCount_res = await this.util.lookCount(this.id) 
		const uploadCount_res = await this.util.uoloadCount(this.id)
		const collect_res = await this.util.collectCount(this.id) 
		const isCollect_res = await this.util.isCollect(this.id) 
		const is_buy = await this.util.is_buy(this.id)
		_this.is_buy = is_buy.data
		_this.lookCount = lookCount_res.browsecount
		_this.collectCount = collect_res.collectcount
		_this.uploadCount = uploadCount_res.downloadsnum
		_this.isCollected = isCollect_res.isCollected
		_this.picture = localStorage.getItem('picture')
		_this.username = localStorage.getItem('username')
		 _this.$Spin.hide()
		 _this.commentList()
	},
	
	// 监听器监听路由的变化
	watch: {
		async '$route'(to,from) {
			let _this = this
			_this.id = _this.$route.query.id
			_this.tid = _this.$route.query.tid
			// 做一些路由变化的响应
			this.binddetailInfo()
			this.bindaboutList() // 获取相关资源
			_this.$Spin.show()
			
			const lookCount_res = await this.util.lookCount(this.id) 
			const collect_res = await this.util.collectCount(this.id) 
			const uploadCount_res = await this.util.uoloadCount(this.id)
			const isCollect_res = await this.util.isCollect(this.id) 
			const is_buy = await this.util.is_buy(this.id)
			_this.is_buy = is_buy.data
			_this.lookCount = lookCount_res.browsecount
			_this.uploadCount = uploadCount_res.downloadsnum
			_this.collectCount = collect_res.collectcount
			_this.isCollected = isCollect_res.isCollected
			_this.picture = localStorage.getItem('picture')
			_this.username = localStorage.getItem('username')
			 _this.$Spin.hide()
			 _this.commentList()
		}
	},

  methods: {
		// 获取导航列表
		async bindNavlist () {
			 let _this = this
			 const res = await _this.get('/spc/cms/col/getAllColBySiteId.do',{siteId:101,chId:35})
			 if ( res.success) {
				 _this.nav_list = res.data.filter(x => x.pId == 35)
				 let arr = _this.nav_list
				 arr.forEach((item) => {
					 item.z_list = res.data.filter(x => x.pId == item.id)
				 })
				 _this.nav_list = arr
			 } else {
				 _this.$Message.error(res.message);
			 }
		 },
		 
		 // 去下载
		 async dowLoadFile () {
		 			 let _this = this
		 			 const res = await _this.util.checkToken()
		 			 if (res.result == 0) {
		 			 		return _this.util.showMsg('warning', res.error.errorMsg,3,false)
		 			 }
		 			 
		 			 const data = await _this.put('/members/downloads', JSON.stringify({doclibid: _this.doclibId,docId: _this.id-0,pageNo:1}))
		 			 // this.dowLoadList()
		 			 window.location.href = _this.$baseURL + '/pub/prodb/attach/api/downLoadFile?recodeID=' + _this.RESOURCEID
		 			 // let data = await _this.get_down('/downLoadFile?recodeID=' + _this.RESOURCEID)
		 },
		 
		 // 点击去支付
		 buydetail () {
			 let _this = this
			 let params = {
				 thirdIden: _this.id,
				 LARGE_PATH: _this.middlePath,
				 doclibName: _this.doclibName,
				 SYS_TOPIC: _this.SYS_TOPIC,
				 price: _this.price
			 }
			 _this.$router.push({path: '/payMant', query:params})
		 },
		 
		 // 进入搜索页面
		 enterSearch (field,q) {
				let link = this.$router.resolve({path: '/search_list',query:{field,q}})
		 			
		 			window.open(link.href, "_blank");
		 },
		 
		 // 显示与否-子导航
		 navMouse (index, state) {
				let _this = this
				let obj = _this.nav_list[index]
				obj.isShow = state
				_this.nav_list.splice(index, 1, obj)
		 },
		 
		 // 获取详情信息
		 async binddetailInfo () {
			 let _this = this
			 const res = await _this.get_res('/docs/'+_this.id+'?sld=AHSCXB&docLibId=' + _this.tid)
			 if (res) {
				 const res_1 = await _this.get_video(res.docId)
				 console.log(res_1)
				 _this.attId = res_1[0]
				 _this.middlePath = res.middlePath
				 _this.SYS_CREATED = res.SYS_CREATED || res.sysCreated
				 _this.SYS_TOPIC = res.SYS_TOPIC || res.docName
				 document.title=_this.SYS_TOPIC
				 _this.RESOURCEID = res.RESOURCEID
				 _this.SUCAIJIESHAO = res.SUCAIJIESHAO || res.DESCRIPTION
				 _this.SYS_AUTHORS = res.SYS_AUTHORS || res.AUTHORS || res.sysAuthors || res.CREATER
				_this.doclibId = res.doclibId || res.sysDoclibid
				_this.doclibName = res.doclibName
				_this.doclibCode = res.doclibCode
				_this.PIC_CAT = res.MEDIA_CAT
				_this.price = res.PRICE || 0
				 if (res.keywords != '' && res.keywords != null) {
						 _this.keywords = res.keywords.split(',') || []
				 }
				 
				 res.more.forEach(x => {
				 					 if (x.name == "文件大小") {
				 						 x.value = ((x.value-0)/1024/1024).toFixed(1) + 'M'
				 					 }
				 })
				 _this.more = res.more
			 }
		 },
		 
		 randomNum(minNum,maxNum){ 
		     switch(arguments.length){ 
		         case 1: 
		             return parseInt(Math.random()*minNum+1,10); 
		         break; 
		         case 2: 
		             return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10); 
		         break; 
		             default: 
		                 return 0; 
		             break; 
		     } 
		 },
		 
		 // 获取相关资源
		 async bindaboutList () {
			 let _this = this
			 const res = await _this.get_res('/docs/'+_this.id+'/getRelResources?sld=AHSCXB&size=4&destDocLibID=' + _this.tid)
			 _this.about_list = res
		 },
		 
		 // 显示与否-子导航
		 navMouse (index, state) {
		 	let _this = this
		 	let obj = _this.nav_list[index]
		 	obj.isShow = state
		 	_this.nav_list.splice(index, 1, obj)
		 },
		 
		 
		 // 收藏操作
		 async collectopt () {
		 			 let _this = this
		 			 if (_this.isCollected) {
		 				 const res = await _this.util.collect_del(_this.doclibId, _this.id)
		 				 _this.$Message.success({
		 						content: '取消收藏成功',
		 						duration: 3
		 					});
		 			 } else {
		 				 const res = await _this.util.collect(_this.doclibId, _this.id)
						 if (res.code == 401) {
						 					 return _this.$Message.error({
						 							content: res.message,
						 							duration: 3
						 						});
						 }
		 				 if (res.iFace) {
		 					 _this.$Message.success({
		 							content: res.iMessage,
		 							duration: 3
		 						});
		 				 }
		 			 }
		 			 const collect_res = await this.util.collectCount(this.id)
		 			 const isCollect_res = await this.util.isCollect(this.id) 
		 			 _this.collectCount = collect_res.collectcount
		 			 _this.isCollected = isCollect_res.isCollected
		 },
		 
		 // 跳转
		 bindlinkTo (path,name) {
				if (path == '') {
					return
				}
				this.$router.push({path,query: {name}})
		 },
		 
		 // 获取评论列表接口
		 async commentList ( isPage = false) {
		 			 let _this = this
		 			 let data = {
		 				 articleId  :_this.id,
		 				 type : 3 ,
		 				 libId : _this.doclibId,
		 				 pageNumber : _this.com_totalPages,
		 				 pageSize: 6
		 			 }
		 			 const res = await _this.post('/spc/discuss/getDiscussList.do?article=' + _this.id + '&type=3' + '&libId=' + _this.doclibId + '&pageNumber=' + _this.com_totalPages + '&pageSize=6')
		 			 if (res.status == 0) {
		 				 _this.com_totalCount = res.data.totalElements
		 				 _this.last = res.data.last
		 				 if (isPage) {
		 					 _this.com_list = [..._this.com_list,...res.data.content]
		 				 } else {
		 					 _this.com_list = res.data.content
		 				 }
		 			 }
		 },
		 
		 changeIndex (index) {
		 			 this.nav_index = index
		 },
		 
		 // 下一页评论
		 commentNext () {
		 			 let _this = this
		 			 _this.com_totalPages++
		 			 _this.commentList(true)
		 },
		 
		 
		 // 发布新评论
		 async commentAdd () {
		 			 let _this = this
		 			 
		 			 if (_this.content== '') {
		 				 return _this.$Message.warning('评论内容不能为空')
		 			 }
		 			 let data = {
		 				 articleId: _this.id,
		 				 articleTopic: _this.SYS_TOPIC,
		 				 channel: 0,
		 				 parentDiscussId: 0,
		 				 parentId: 0,
		 				 siteId: 110,
		 				 type: 3,
		 				 userId: localStorage.getItem('id'),
		 				 userName: localStorage.getItem('username'),
		 				 doclibId: _this.doclibId,
		 				 doclibName: _this.doclibName,
		 				 starScore:10,
		 				 content: _this.content
		 			 }
		 			 // const res = await _this.post_res('/members/addComment', data)
		 			 const res = await _this.post('/spc/discuss/saveDiscuss.do', data)
		 			 if (res.status == 0) {
		 				 _this.$Message.success( res.message )
		 				 _this.content= ''
		 				 // setTimeout(() => {window.location.reload()},1500)
		 				 _this.commentList()
		 			 } else {
		 				 _this.$Message.warning( res.message)
		 			 }
		 }
	},
	
	beforeDestroy () {
		document.title= '图片安徽'
	},
}
</script>

<style lang="less" scoped>
	
	.detail-box {
		background-color: #f1f2f6;
		padding-bottom: 120px;
	}
	.detail-main {
		width: 1200px;
		margin: 0 auto;
	}
	.iconxiangyoujiantou {
		font-size: 12px;
		color: #666;
	}
	
	// 图片详情左侧内容
	.img-detail-left {
		width: 800px;
		.title-ion {
			width: 22px;
			height: 27px;
		}
		.detail-img {
			border-radius: 3px;
			width: 760px;
			height: 430px;
			video {
				width: 100%;
				height: 100%;
			}
		}
		.detail-img-mask {
			height: 60px;
			background-color: #cfd8dc;
			li {
				width: 100px;
				height: 100%;
				line-height: 60px;
				color: #78909c;
				font-size: 14px;
				cursor: pointer;
			}
			.on {
				background-color: #fff;
				color: #000;
			}
		}
	}
	
	.detail-mask {
		.banquan {
			background-color: #f9f2e6;
			border: 1px #f4e6cf solid;
			padding: 15px 15px;
			border-radius: 5px;
		}
		
	}
	
	.img-detail-right {
		width: 385px;
	}
	.user-info {
		.head {
			width: 36px;
			height: 36px;
			border-radius: 50%;
		}
		.vip-icon {
			width: 25px;
			height: 19px;
		}
		.vip-qq {
			width: 13px;
			height: 17px;
		}
		.tc-detail {
			width: 320px;
			height: 50px;
			background-color: #f8f8f8;
			margin-top: 12px;
		}
		.down-btn {
			width: 190px;
			height: 52px;
			background-color: #3a5e98;
		}
		.collect-btn {
			height: 52px;
			border: 1px solid #3a5e98;
			color: #3a5e98;
			background-color: #eff4fa;
		}
		.cz-btn {
			width: 320px;
			margin: 25px auto 7px;
		}
	}
	.detail-ty-box {
		height: 70px;
	}
	.detail-design {
		padding: 2px 10px;
		border: 1px solid #ececec;
	}
	.detail-about-img {
		width: 110px;
		height: 70px;
	}
	
	.bg-box {
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 0;
		overflow: hidden;
		img {
			max-width: 100%;
			width: 100%;
			height: 100%;
			-webkit-filter: blur(50px);
			-moz-filter: blur(50px);
			-ms-filter: blur(50px);
			filter: blur(50px);
			filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius=6, MakeShadow=false);
			filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius='6', MakeShadow='true', ShadowOpacity='0.3');
		}
	}
	.bg-box::before {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		content: '';
		z-index: 1;
		background-color: rgba(0, 0, 0, 0.3);
	}
	.detail-audio-center {
		top: 60px;
		left: 50%;
		transform: translateX(-50%);
		width: 240px;
		height: 240px;
		background: url(../assets/images/audiopan.png) no-repeat center;
		background-size: 100% 100%;
		.bg-img {
			width: 150px;
			height: 150px;
			border-radius: 50%;
		}
		.caoz-btn {
			width: 80px;
			height: 80px;
			border-radius: 50%;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
		}
	}
	
	video::-internal-media-controls-download-button {
			display:none;
	}
	video::-webkit-media-controls-enclosure {
			overflow:hidden;
	}
	video::-webkit-media-controls-panel {
			width: calc(100% + 30px);
	}
	
	// 音乐详情盒子
	.music-list .music-detail-box:nth-child(4n) {
		margin-right: 0;
	}
	.music-detail-box {
		width: 280px;
		height: 160px;
		margin-right: 26px;
		box-shadow: 0 0px 2px rgba(0, 0, 0, 0.1);
		transition: all .3s;
		border-radius: 4px;
		img {
			width: 100%;
			height: 100%;
		}
		.absolute {
			bottom: 0;
			width: 100%;
			color: #fff;
			font-size: 14px;
		}
		.iconbofang {
			font-size: 16px!important;
		}
	}
	
	
	
		// 新家评论
		.comment-add {
			.add-btn {
				background-color: #339EF4;
				color: #FFF;
				width: 138px;
				height: 138px;
				line-height: 138px;
				font-size: 14px;
				text-align: center;
			}
			textarea {
				height: 138px;
				border: 1px solid #CBCBCB;
				padding: 10px;
				box-shadow: inset 0 1px 2px rgb(0 0 0 / 12%);
				resize:none
			}
			.head-img {
				width: 50px;
				height: 50px;
				border-radius: 50%;
				margin-right: 40px;
			}
		}
		
		.comment-list {
			.head-img {
				width: 44px;
				height: 44px;
				border-radius: 50%;
			}
			.comment-detail {
				border-bottom: 1px solid #eee;
			}
			.num {
				font-size: 19px;
				font-style: italic;
				font-family: "Open Sans",Arial,sans-serif;
				color: #c8c8c8;
			}
			.name {
				color: #2196f3;
			}
			.date {
				color: #B0BEC5;
			}
		}
	
	
	input:focus, textarea:focus {
	    outline: none;
	}
</style>
